import { InputField } from 'components/molecules'

const MarketingDiscountBatchCodeField = () => (
  <InputField
    name='code'
    label='Discount Batch Code'
    placeholder='Discount Batch Code'
    type='text'
  />
)

export default MarketingDiscountBatchCodeField
